import gql from 'graphql-tag';

const getCardCategoryHierarchyQuery = gql`
  query getCardCategoryHierarchyQuery($offset: Int = 0, $limit: Int = 200) {
    cardCategories(
      slice: { offset: $offset, limit: $limit }
      root_only: false
      is_active: true
    ) {
      total
      records {
        id
        parent {
          id
        }
      }
    }
  }
`;

export default getCardCategoryHierarchyQuery;
